// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ShopriteCard/ShopriteCard.css
// module id = 455
// module chunks = 0